import _ from 'lodash'
// import { questionData, screenData } from '../assets/data/data'
export default {
  // random dna with highest number(upperpound)
  getRandomNotDuplicate: (state) => (upperbound) => {
    let uniquerandom = []
    while (uniquerandom.length < 2) {
      let randomnumber = Math.round(Math.random() * (upperbound - 1) + 1)
      // if random number haven't exist in array, add it to array
      if (uniquerandom.indexOf(randomnumber) === -1) {
        uniquerandom.push(randomnumber)
      }
    }
    return uniquerandom
  },
  // Create 2 Horse, method is call in action
  get2Horse: (state, getters) => () => {
    state.horseUser = getters.getCalculateStatus()
    // if user replay game horseUser color will be 0(special)
    state.horseUser.color = state.replaySpecialcard ? 0 : _.random(1, 5)
    state.horsePc = getters.getCalculateStatus()
    state.horsePc.color = 6
    state.temp = 0
    // console.log(state.horseUser)
    // console.log(state.horsePc)
  },
  getMyHorse: (state) => {
    return state.horseUser
  },
  getCalculateStatus: (state, getters) => () => {
    let dnasex = []
    let arraydna1 = []
    let arraydnaA1 = []
    let arraydnaA2 = []
    let arraydna2 = []
    let arraydnaB1 = []
    let arraydnaB2 = []
    let arraydna3 = []
    let arraydnaC1 = []
    let arraydnaC2 = []
    let arraydna4 = []
    let arraydnaD1 = []
    let arraydnaD2 = []
    let horse = {
      speed: 0,
      stamina: 0,
      brave: 0,
      calm: 0,
      health: 0,
      sex: ''
    }
    let arrayStatusB = ['speed', 'stamina', 'health']
    // create dna 1 , highest number in first play is 6
    let dna1 = getters.getRandomNotDuplicate(6)
    let dna2 = getters.getRandomNotDuplicate(6)
    let dna3 = getters.getRandomNotDuplicate(6)
    do {
      dnasex = getters.getRandomNotDuplicate(12)
    } while (dnasex[0] > 6 && dnasex[1] > 6)
    let arrayStatusA = ['speed', 'stamina', 'brave', 'calm', 'health']
    // for each val in array, calculate status
    _.mapKeys(arrayStatusA, (val) => {
      horse[val] += getters.getCalculate(dna1, 0, state.data[val])
    })
    // slipt number of dna array 1 and bring to each array
    getters.getStatusEachDna(arraydna1, arraydnaA1, arraydnaA2)
    _.mapKeys(arrayStatusB, (val) => {
      horse[val] += getters.getCalculate(dna2, 1, state.data[val])
    })
    getters.getStatusEachDna(arraydna2, arraydnaB1, arraydnaB2)
    horse.speed += getters.getCalculate(dna3, 2, state.data.speed)
    horse.stamina += getters.getCalculate(dna3, 2, state.data.stamina)
    horse.brave += getters.getCalculate(dna3, 1, state.data.brave)
    getters.getStatusEachDna(arraydna3, arraydnaC1, arraydnaC2)
    // if both sexdna > 6 rerandom number
    horse.calm += getters.getCalculate(dnasex, 1, state.data.calm)
    horse.sex = getters.getCalculate_sex(dnasex)
    getters.getStatusEachDna(arraydna4, arraydnaD1, arraydnaD2)
    if (state.temp === 0) {
      // temp is variable, use for horse user to show 8 card
      state.arrayTotalDNA.A1 = getters.arrageEachDnaUser(arraydnaA1, 'A1')
      state.arrayTotalDNA.A2 = getters.arrageEachDnaUser(arraydnaA2, 'A2')
      state.arrayTotalDNA.B1 = getters.arrageEachDnaUser(arraydnaB1, 'B1')
      state.arrayTotalDNA.B2 = getters.arrageEachDnaUser(arraydnaB2, 'B2')
      state.arrayTotalDNA.C1 = getters.arrageEachDnaUser(arraydnaC1, 'C1')
      state.arrayTotalDNA.C2 = getters.arrageEachDnaUser(arraydnaC2, 'C2')
      state.arrayTotalDNA.D1 = getters.arrageEachDnaUser(arraydnaD1, 'D1')
      state.arrayTotalDNA.D2 = getters.arrageEachDnaUser(arraydnaD2, 'D2')
    }
    state.temp++
    state.array_temp = []
    return horse
  },
  // function calulate for each health brave calm stamina
  getCalculate: (state, getters) => (array, arrayTitle, arrayName) => {
    let summary = 0
    for (let i in array) {
      summary += arrayName[arrayTitle][array[i] - 1]
      // push dna information to array to show 8 card
      state.array_temp.push(arrayName[arrayTitle][array[i] - 1])
    }
    return summary
  },
  //  if exist dna > 6 return male
  getCalculate_sex: (state, getters) => (array) => {
    array[0] > 6 ? state.array_temp.push('Y') : state.array_temp.push('X')
    array[1] > 6 ? state.array_temp.push('Y') : state.array_temp.push('X')
    return (array[0] > 6 || array[1] > 6) ? 'オス' : 'メス'
  },
  // split array bring it to array
  getStatusEachDna: (state, getters) => (array, arrayA, arrayB) => {
    if (state.temp === 0) {
      array = state.array_temp
      state.array_temp = []
      _.forIn(array, function (value, key) {
        _.parseInt(key) % 2 === 0 ? arrayA.push(value) : arrayB.push(value)
      })
    }
  },
  // random dice after one turn
  getRandomDice: (state, getters) => (horse) => {
    // random without number input horse, if user turn random for user
    if (horse === 'horseUser') {
      state.dice.user[0] = _.random(1, 6)
      state.dice.user[1] = _.random(1, 6)
    } else {
      state.dice.pc[0] = _.random(1, 6)
      state.dice.pc[1] = _.random(1, 6)
    }
  },
  // calculate basic with dice number (which horse user or pc)
  getBasicMethod: (state, getters) => (horse, turnremain, diceData) => {
    if (state.turn < 11) return 2 + ((((turnremain - state.turn) * horse.speed * diceData[0]) + (state.turn * horse.stamina * diceData[0])) / 50)
    else return 2 + (((1 * horse.speed * diceData[0]) + (10 * horse.stamina * diceData[0])) / 50)
  },
  // calulate calm with dice number
  getCalmMethod: (state, getters) => (horse, diceData) => {
    return ((diceData[0] + horse.calm) >= 6) ? 1 : 0.8
  },
  // calulate brave with dice number
  getBraveMethod: (state, getters) => (horse, diceData) => {
    return (state.turn > 1) ? (horse.brave + diceData[1]) > 8 ? 1 + (0.1 * horse.brave) : 1 : 1 + (0.1 * horse.brave)
  },
  // calulate health with dice number
  getHealthMethod: (state, getters) => (horse, diceData) => {
    return (diceData[0] + diceData[1] >= 10) ? 0.2 + 0.1 * horse.health : 1
  },
  // calulate distance with dice number
  getDistanceMethod: (state, getters) => (horse, basicDice, braveDice, calmDice, healthDice, result) => {
    let distance = 0
    // whether horse male or female if male return 1.05
    let ismale = (horse.sex === 'オス') ? 1.05 : 1
    if (state.turn > 1) {
      distance = ismale * basicDice * result * calmDice * healthDice
    } else {
      // first turn dice
      distance = ismale * basicDice * braveDice * calmDice * healthDice
    }
    // get 4 number after comma
    return Number((distance).toFixed(4))
  },
  getCalculateDistance: (state, getters) => (horse) => {
    let distanceOneTurn = 0
    let turnRemain = 11
    let result = 1
    let horseData
    if (horse === 'horseUser') {
      state.isAsmallerB = (state.finalDistanceA <= state.finalDistanceB)
      state.turn++
    }
    // if replay = true, horseUser = specialCard
    if (state.replaySpecialcard === true) {
      horseData = horse === 'horseUser' ? state.specialCard : state.horsePc
    } else {
      horseData = horse === 'horseUser' ? state.horseUser : state.horsePc
    }
    let diceData = horse === 'horseUser' ? state.dice.user : state.dice.pc
    let basicDice = getters.getBasicMethod(horseData, turnRemain, diceData)
    let braveDice = getters.getBraveMethod(horseData, diceData)
    let calmDice = getters.getCalmMethod(horseData, diceData)
    let healthDice = getters.getHealthMethod(horseData, diceData)
    if (horse === 'horseUser') {
      // if distance A <distance B return brave is caculated with dice
      result = (state.isAsmallerB === true) ? braveDice : 1
      // calculate distance after one turn
      distanceOneTurn = getters.getDistanceMethod(horseData, basicDice, braveDice, calmDice, healthDice, result)
      state.distanceOneTurnA = distanceOneTurn * 25
      state.finalDistanceA += state.distanceOneTurnA
    } else {
      result = (state.isAsmallerB === false) ? braveDice : 1
      distanceOneTurn = getters.getDistanceMethod(horseData, basicDice, braveDice, calmDice, healthDice, result)
      state.distanceOneTurnB = distanceOneTurn * 25
      state.finalDistanceB += state.distanceOneTurnB
    }
    getters.winCondition()
  },
  // function is called in action.js
  buttonDiceClick: (state, getters) => () => {
    // compare distance A and B, return true if A <B
    getters.getRandomDice('horseUser')
    getters.getCalculateDistance('horseUser')
    getters.getRandomDice('horsePc')
    getters.getCalculateDistance('horsePc')
  },
  // condition which one > 2000, that horse win
  winCondition: (state, getters) => () => {
    if (state.finalDistanceA >= 2000) {
      state.isWin = true
    } else if (state.finalDistanceB >= 2000) {
      state.isWin = false
    }
  },
  arrageEachDnaUser: (state, getters) => (array, arrayname) => {
    let temp = {}
    if (arrayname === 'A1' || arrayname === 'A2') {
      temp.speed = array[0]
      temp.stamina = array[1]
      temp.brave = array[2]
      temp.calm = array[3]
      temp.health = array[4]
    } else if (arrayname === 'B1' || arrayname === 'B2') {
      temp.speed = array[0]
      temp.stamina = array[1]
      temp.brave = ''
      temp.calm = ''
      temp.health = array[2]
    } else if (arrayname === 'C1' || arrayname === 'C2') {
      temp.speed = array[0]
      temp.stamina = array[1]
      temp.brave = array[2]
      temp.calm = ''
      temp.health = ''
    } else if (arrayname === 'D1' || arrayname === 'D2') {
      temp.sex = array[1]
      temp.speed = ''
      temp.stamina = ''
      temp.calm = array[0]
      temp.brave = ''
    }
    return temp
  },
  specialCard: (state, getters) => (card) => {
    state.replaySpecialcard = true
    let temp = _.cloneDeep(state.arrayTotalDNA)

    // console.log('before----state.arrayTotalDNA----', _.pick(state.arrayTotalDNA, ['A1', 'A2']))
    // Set new value for special card
    _.map(temp[card], (val, key) => { temp[card][key] = 3 })
    // Reset value if last special card have been set and different with new special card id
    if (state.adnSpecial !== card && state.adnSpecial !== -1) {
      let oldCard = state.adnSpecial
      temp[oldCard] = _.cloneDeep(state.arrayTotalDNA[oldCard])
    }

    // Update new value for card spec after change special card
    let keyArr = ['speed', 'stamina', 'brave', 'calm', 'health']
    _.map(keyArr, (val) => {
      state.specialCard[val] = _.sum(_.map(temp, (v) => { return _.toInteger(v[val]) })) || ''
    })
    state.specialCard.sex = state.horseUser.sex
    state.specialCard.color = 0
    state.arraySpecialDNA = temp

    // console.log('after----temp----', _.pick(temp, ['A1', 'A2']))
    // console.log('before----state.horseUser----', _.pick(state.horseUser, keyArr))
    // console.log('after----state.specialCard-----', _.pick(state.specialCard, keyArr))
  },
  getResetDistance: (state, getters) => () => {
    state.finalDistanceA = 0
    state.distanceOneTurnA = 0
    state.finalDistanceB = 0
    state.distanceOneTurnB = 0
    state.turn = 0
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js